// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_DEPARTMENTS_REQUEST,
  DELETE_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_RELEASE_REQUEST,
  OPEN_EDIT_PAGE_DEPARTMENT,
} from './actionTypes';
import {
  fetchDepartmentsSuccess,
  fetchDepartmentsFailure,
  deleteDepartmentSuccess,
  deleteDepartmentFailure,
  fetchDepartmentSuccess,
  fetchDepartmentFailure,
  updateDepartmentSuccess,
  updateDepartmentFailure,
  openEditPageDepartmentSuccess,
} from './actions';
import { deleteDepartment, getAllDepartments, getDepartment, updateDepartment } from '../../helpers/backend_helper';
import { reduxSerializedError } from '../../utils/utils';

function* fetchDepartmentsSaga() {
  try {
    const response = yield call(getAllDepartments);
    yield put(fetchDepartmentsSuccess(response));
  } catch (error) {
    yield put(fetchDepartmentsFailure(reduxSerializedError(error)));
  }
}


function* fetchDepartmentSaga({ payload }) {
  try {
    const response = yield call(getDepartment, payload);
    yield put(fetchDepartmentSuccess(response));
  } catch (error) {
    yield put(fetchDepartmentFailure(reduxSerializedError(error)));
  }
}

function* deleteDepartmentsSaga({ payload }) {
  try {
    yield call(deleteDepartment, payload);
    yield put(deleteDepartmentSuccess(payload));
    yield call(fetchDepartmentsSaga); // Refresh the department list
  } catch (error) {
    yield put(deleteDepartmentFailure(reduxSerializedError(error)));
  }
}

function* updateDepartmentSaga({ payload }) {
  const { department, navigate } = payload;
  try {
    yield call(updateDepartment, department);
    yield put(updateDepartmentSuccess());
    navigate('/departments');
    yield call(fetchDepartmentsSaga); // Refresh the department list
  } catch (error) {
    yield put(updateDepartmentFailure(reduxSerializedError(error)));
  }
}

function* openEditPageDepartmentSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/departments/${id}`);
    yield put(openEditPageDepartmentSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_DEPARTMENTS_REQUEST, fetchDepartmentsSaga);
  yield takeEvery(FETCH_DEPARTMENT_REQUEST, fetchDepartmentSaga);
  yield takeEvery(UPDATE_DEPARTMENTS_REQUEST, updateDepartmentSaga);
  yield takeEvery(DELETE_DEPARTMENTS_REQUEST, deleteDepartmentsSaga);
  yield takeEvery(OPEN_EDIT_PAGE_DEPARTMENT, openEditPageDepartmentSaga);
}
